<template>
  <div id="choose-row-nume">
    <!-- 选择排号规则 -->
    <div class="line">
      <div class="title">排号方式:</div>
      <div class="value">
        <el-radio-group v-model="data.type" @change="changeType">
          <el-radio :label="'0'">系统排号</el-radio>
          <el-radio :label="'1'">人工排号</el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="line col-line" v-show="data.type == '1'">
      <!-- 人工排号才显示人员列表 -->
      <!-- <el-table
        ref="multipleTable"
        :data="userArray"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="name" label="姓名"> </el-table-column>
      </el-table> -->
      <div
        class="item"
        v-for="(item, index) in data.userList"
        :key="index"
        @click="item.flag = !item.flag"
      >
        <el-checkbox v-model="item.flag">{{ item.name }}</el-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "diy_dialog_choose_row_number",
  props: {
    chooseNumData: {
      type: Object,
      default: function () {
        return {
          type: "0", // 排号方式, 0 机器排号  1 人工排号
          userList: [], // 学员
        };
      },
    },
    department: {
      type: Array,
      default: function () {
        return [];
      },
    },
    professional: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      data: this.chooseNumData,
      userArray: [],
      flag: true, // 是否人工排号
      multipleSelection: [],
    };
  },
  watch: {
    chooseNumData() {
      this.data = this.chooseNumData;
    },
    data(newValue) {
      this.$emit("showNum", this.data);
    },
  },
  methods: {
    /**
     * 获取满足当前考试的部门及专业的所有学员
     */
    async setExamPlanUser() {
      try {
        let resultData = await this.$request({
          url: "/examPlan/setExamPlanUser",
          method: "post",
          data: {
            department: this.department,
            professional: this.professional,
          },
        });
        this.data.userList = [];
        resultData.forEach((element) => {
          this.$set(element, "flag", true);
          this.data.userList.push(element);
        });
        this.userArray = JSON.parse(JSON.stringify(this.data.userList));
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    changeType(type) {
      switch (type) {
        case "0":
          // 系统排号
          this.data.userList = JSON.parse(JSON.stringify(this.userArray));
          this.data.userList.forEach((element) => {
            element.flag = true;
          });
          this.flag = false;
          break;
        case "1":
          // 人工排号
          this.flag = true;
          break;

        default:
          break;
      }
    },
  },
  async mounted() {
    await this.setExamPlanUser();
  },
};
</script>

<style lang="less" scoped>
#choose-row-nume {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  > .line {
    width: 100%;
    height: auto;
    min-height: 30px;
    display: flex;
    > .title {
      width: 120px;
      display: flex;
      align-items: center;
      font-size: 15px;
      font-weight: bold;
      justify-content: flex-end;
      margin-right: 10px;
    }
    > .value {
      width: 0;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
  }
  > .col-line {
    flex-direction: column;
    > .item {
      width: 100%;
      height: 35px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      box-sizing: border-box;
      padding: 0 50px;
      border-bottom: 1px solid #e9e9e9;
    }
  }
}
</style>